module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921001151_T.697741ec.jpg";